export const InviteFooter = () => {
  return (
    <div className="flex w-full flex-col gap-16 bg-Gray-700 px-20 py-60">
      <h3 className="text-center font-700 text-Gray-300 typo-body1">
        웰로 친구 초대 이벤트 유의사항
      </h3>
      <ul className="flex flex-col gap-8 break-all pb-120">
        {[
          '본 이벤트는 ㈜웰로가 주관하며, 고향사랑기부제 참여 유도 및 공유 활성화를 위한 이벤트입니다.',
          '기부횟수 동점자가 나올 경우, 먼저 기부횟수가 누적된 유저에게 등수가 주어집니다. 예를 들어, 친구 기부 횟수가 10명으로 동점인 경우, 먼저 친구기부횟수 10명을 달성한 유저가 높은 등수를 갖게 됩니다.',
          '추가 혜택은 10만 원 이상 기부자 대상으로 진행됩니다.',
          '기부횟수 동점자가 나올 경우, 먼저 기부횟수가 누적된 유저에게 등수가 주어집니다. 예를 들어, 친구 기부 횟수가 10명으로 동점인 경우, 먼저 친구기부횟수 10명을 달성한 유저가 높은 등수를 갖게 됩니다.',
          '기존 웰로 회원을 초대할 경우 혜택 대상에서 제외됩니다.',
          '본 이벤트 기간 지급된 네이버페이 포인트는 지급일로부터 1개월 후 자동 소멸됩니다. 유효기간 내 미사용 시, 재지급이 어렵습니다.',
          '친구 초대를 통한 리워드 정책은 추후 변경될 수 있습니다.',
          '부적절한 방법으로 친구초대 참여 확인 시, 지급된 포인트 회수 및 당첨 취소, 영구 참여 제한 조치 등이 적용될 수 있습니다.',
          '초대받은 친구가 가입 후 ‘본인 인증’ 미완료한 경우, 혜택이 지급되지 않습니다.',
          '초대받은 친구가 탈퇴 후 재가입할 경우, 재지급이 어렵습니다.',
          '이벤트 기간 중에 친구가 회원 탈퇴 후 재가입 시 ‘초대 횟수에’ 반영되지 않습니다.',
          '본 이벤트 추가 당첨 지원금 제세공과금(22%) 대상이며, 해당 금액은 당첨자 부담입니다.',
          '이벤트 리워드는 회원 정보(휴대폰 번호 및 계정 정보) 기준으로 지급되며, 등록 오류로 인한 미지급에 대한 별도 보상은 제공되지 않습니다.',
          '선착순 지원금은 선착순으로 소진되며, 조기 마감 시 별도 공지 없이 종료될 수 있습니다.',
          '제세공과금 대리 납부를 위해 당첨자의 개인정보(성명, 생년월일, 주민등록번호, 주소 등)를 수집하며, 정보 제공을 거부할 경우 당첨이 취소될 수 있습니다.',
          '본 이벤트 경품 지급 시, 신분증 또는 본인 확인이 가능한 증빙 서류 제출을 요청할 수 있으며, 본인 확인이 불가능하거나 제세공과금 미납 시 경품 지급이 제한됩니다.',
          '본 이벤트는 내부 사정 또는 외부 제휴사의 요청으로 사전 고지 없이 변경되거나 중단될 수 있습니다.',
        ].map((item, index) => (
          <li key={index} className="flex items-start gap-8">
            <span className="mt-1 shrink-0 text-Gray-550 typo-body4">
              •
            </span>
            <span className="text-Gray-550 typo-body4">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
